
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { TemplateItemProps } from ".";
import { loading, index, options } from "store/template";

interface ApiTemplateInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiTemplateOutputProps = OutputBaseProps<{ list: TemplateItemProps[]; pagination?: PaginationProps; }>

export const apiTemplateIndex = async (data: ApiTemplateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTemplateOutputProps>("/api/templates", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiTemplateOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTemplateOutputProps>("/api/templates", { params: { ...data } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};